import { BaseInput, type BaseInputProps } from "./BaseInput";

type TextInputProps = BaseInputProps;

export function TextInput({ classes, ...props }: TextInputProps) {
  return <BaseInput {...props} type="text" classes={classes} />;
}
